<template>
  <q-fila v-if="aplica" :label="label" :ayuda="ayuda" :completa="alMenosUna" :resaltar="resaltar">
    <div class="d-flex flex-wrap">
      <b-form-checkbox v-for="op in opciones" :key="op.campo" size="lg"
                       class="mb-2 mr-4"
                       :checked="valores[op.campo] === true"
                       :disabled="soloLectura"
                       @input="marcar(op.campo, $event)">{{ op.etiqueta }}</b-form-checkbox>
    </div>
    <slot name="dependiente"></slot>
  </q-fila>
</template>

<script>
import QFila from "./QFila";

/**
 * Selección múltiple sobre opciones fijas: cada opción es su propia columna
 * booleana, siguiendo la metodología del proyecto (no se guarda una lista).
 */
export default {
  name: "QMultiple",
  components: { QFila },
  props: {
    // objeto del modelo que contiene las columnas de las opciones
    valores: { type: Object, required: true },
    label: { type: String, required: true },
    ayuda: { type: String, default: "" },
    opciones: { type: Array, required: true },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
  },
  computed: {
    alMenosUna() {
      return this.opciones.some((op) => this.valores[op.campo] === true);
    },
  },
  methods: {
    marcar(campo, valor) {
      if (this.soloLectura) return;
      this.$emit("cambio", { campo: campo, valor: valor === true ? true : null });
    },
  },
};
</script>
